import { useState } from "react";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./components/LoginPage";
import Navbar from "./components/Navbar";
import RegisterPage from "./components/RegisterPage";

import ManageRooms from "./components/ManageRooms";
import RoomBookingPreview from "./components/RoomBookingPreview";
import RoomBlockingPreview from "./components/RoomBlockingPreview";
import BookingSummary from "./components/BookingSummary";
import TermsAndConditions from "./components/TermsAndConditions";
import Home from "./components/Home";
import Contact from "./components/Contact";
import ForgotPassword from "./components/ForgotPassword";
import MyBookings from "./components/MyBookings";
import BookedReports from "./components/BookedReports";
import BlockedReports from "./components/BlockedReports";
import CancelledReports from "./components/CancelledReports";

import Accom from "./components/Accom";

import Reports from "./components/Reports";
import PreviewPage from "./components/PreviewPage";
import Footer from "./components/Footer";

import LocationDetails from "./components/LocationDetails";
import Disaccount from "./components/Disaccount";
import RIbookings from "./components/RIbookings";
import AObookings from "./components/AObookings";
import CAObookings from "./components/CAObookings";
import Terms_conditions from "./components/Terms_conditions";
import LocationHandler from "./components/LocationHandler";
import Blockeddata from "./components/BlockedData";
import UserBlockedData from "./components/UserBlockedData";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };
  return (
    <Router>
      <Routes>
        <Route path="/Login" element={<LoginPage />} />
        <Route path="/Register" element={<RegisterPage />} />
      
        <Route path="/manage-venue" element={<ManageRooms />} />
        <Route path="/roombookingpreview" element={<RoomBookingPreview />} />
        <Route path="/roomBlockingPreview" element={<RoomBlockingPreview />} />
        <Route path="/bookingSummary" element={<BookingSummary />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/MyBookings" element={<MyBookings />} />
        <Route path="/Booked-Reports" element={<BookedReports />} />
        <Route path="/Blocked-Reports" element={<BlockedReports />} />
        <Route path="/Cancelled-Reports" element={<CancelledReports />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
       
        <Route path="/" element={<Accom />} />
       
        <Route path="/Booked-Reports" element={<Reports />} />

      
       
        <Route path="/bookingpreview" element={<PreviewPage />} />
        <Route path="/Venue-details" element={<LocationDetails />} />
        <Route path="/location/:id" element={<LocationHandler />} />
        <Route path="discount" element={<Disaccount />} />
        <Route path="RIbookings" element={<RIbookings />} />
        <Route path="/AObookings" element={<AObookings />} />
        <Route path="/CAObookings" element={<CAObookings />} />
        <Route path="/termsandconditions" element={<Terms_conditions />} />
        <Route path="/blocked-data" element={<Blockeddata />} />
        <Route path="/user-blocked-data" element={<UserBlockedData />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
